import { graphql } from "../../graphql";

export const MfaStateQuery = graphql(`
  query MfaState($userId: String!, $orgId: Int!) {
    folio_user(where: { id: { _eq: $userId } }) {
      mfa_opted_out
    }
    organisation(where: { id: { _eq: $orgId } }) {
      mfa_mode
    }
  }
`);

export const SetMfaOptOutMutation = graphql(`
  mutation SetMfaOptOut($userId: String!) {
    update_folio_user(where: { id: { _eq: $userId } }, _set: { mfa_opted_out: true }) {
      affected_rows
    }
  }
`);
